import { render } from "./IndexCenter.vue?vue&type=template&id=376194dc"
import script from "./IndexCenter.vue?vue&type=script&lang=js"
export * from "./IndexCenter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__